export const INFO_TITLE =
	'Provide payment information and grant Orthosnap permission to use this to pay your outstanding invoices.';
export const INFO_TEXT =
	'The total amount to be charged is the value presented in Outstanding invoices. Click “Permit“ to authenticate payment for every single invoice  of outstanding amount by one payment method (Credit Card) you will provide on the next step';
